import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NzCarouselComponent } from "ng-zorro-antd/carousel";
import { AppService } from "src/app/app.service";
import {
  VAIconRegistryService,
  expandDoubleArrows,
  greaterThan,
  lessThan,
} from "@va/core-library/icons";

@Component({
  selector: "app-research-chart-carousel",
  templateUrl: "./research-chart-carousel.component.html",
  styleUrls: ["./research-chart-carousel.component.scss"],
  host: { class: "research-chart-component" },
  encapsulation: ViewEncapsulation.None,
})
export class ResearchChartCarouselComponent implements OnInit {
  @Input() tickerDetails: any;
  @Input() lineItem: any;
  chartType: string;
  dataSet: boolean;
  dataToUse: any;
  chartSubType: string;
  defaultData: any;
  orignalPeriod: any;
  chartList: any[];
  selectedValue: string;
  beginningStateReferrer: string;
  effect = "scrollx";
  @ViewChild(NzCarouselComponent)
  chartCarousel: NzCarouselComponent;
  logSwitch: boolean;
  displayData: any = {};
  displayDataSet = false;
  chartPopupType: string;
  chartPopupDataToUse: any;
  chartPopupVisible = false;
  feature = "RESEARCH_PAGE";
  constructor(
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      expandDoubleArrows,
      lessThan,
      greaterThan,
    ]);
  }

  ngOnInit() {
    this.chartType = "trend-bar";
    this.beginningStateReferrer = "Chart_Trends_Bar";

    // this.tickerDetails = {
    //   name: "American Airlines Group Inc.",
    //   symbologycompanyid: 110834,
    //   ticker: "AAL"
    // }
    // this.lineItem ={"status": "success", "dapparameterid": 9480955, "line_item_name": "Total passenger revenue", "current_quarter": "2QFY-2020", "period": "FY-2020"};
    this.dataSet = false;
  }
  ngOnChanges(changes: SimpleChanges) {
    this.dataSet = false;
    if (
      changes.lineItem &&
      changes.lineItem.currentValue !== undefined &&
      this.chartType !== undefined &&
      changes.lineItem.currentValue.dapparameterid
    ) {
      this.setDefaults();
      this.dataSet = true;
      setTimeout(() => {
        const slideIndex = this.chartList.indexOf(this.selectedValue);
        this.chartCarousel.goTo(Number(slideIndex));
      }, 100);
    }
  }

  setDefaults() {
    //update this function to fit research carousel
    this.dataToUse = {
      companyFullName: this.tickerDetails.name,
      period: this.lineItem.period,
      source: "Consensus",
      forecast: true,
      cut: "NMV",
      isPeers: false,
      gAdjust: "implied",
      dapparamId: this.lineItem.dapparameterid,
      ticker: this.tickerDetails.ticker,
      export: true,
      currentQuarter: this.lineItem.current_quarter,
    };
    this.defaultData = {
      ...this.dataToUse,
      sourceList: {
        headerText: "Source",
        list: [],
      },
      showSourceList: false,
      peersList: {
        headerText: "Peers",
        list: [],
      },
      showPeersList: false,
      displayDataSet: false,
    };
    this.orignalPeriod = this.lineItem.period;

    this.chartSubType = "bar";
    this.chartList = [
      "distribution-analysis",
      "distribution-range",
      "trend-bar",
      "revision-daily",
      "revision-monthly",
      "revision-analysis",
    ];

    if (this.chartType.indexOf("-") !== -1) {
      const obj = this.chartType.split("-");
      this.chartType = obj[0].toLowerCase();
      this.chartSubType = obj[1].toLowerCase();
    }
    this.selectedValue = `${this.chartType.toLowerCase()}-${this.chartSubType.toLowerCase()}`;
    const extraData = {
      period: this.lineItem.period,
      line_id: this.lineItem.dapparameterid.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.tickerDetails.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Open",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }
  getFeatureName(selectedVal: string) {
    let featureName = "";
    switch (selectedVal) {
      case "distribution-analysis":
        featureName = "Chart_Distribution_Waterfall";
        break;
      case "distribution-range":
        featureName = "Chart_Distribution_HighLow";
        break;
      case "trend-bar":
        featureName = "Chart_Trends_Bar";
        break;
      case "revision-daily":
        featureName = "Chart_Revisions_Source_DailyLTM";
        break;
      case "revision-monthly":
        featureName = "Chart_Revisions_Source_Monthly2Y";
        break;
      case "revision-analysis":
        featureName = "Chart_Revision_Source_Analysis";
        break;
      default:
        featureName = "";
    }
    return featureName;
  }
  onChartTypeChange() {
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];
    const slideIndex = this.chartList.indexOf(this.selectedValue);
    this.logSwitch = true;
    this.chartCarousel.goTo(Number(slideIndex));
  }
  carouselChange(index) {
    if (index >= this.chartList.length) {
      index = 0;
    }
    if (index < 0) {
      index = this.chartList.length - 1;
    }
    this.selectedValue = this.chartList[index];
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];

    // flag to distinguish between actual chart switch and false chart switch triggered on component load.
    if (this.logSwitch === true) {
      this.logChartSwitch();
    }
  }

  logChartSwitch() {
    this.logSwitch = false;
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Switch",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }

  prevChart() {
    this.logSwitch = true;
    this.chartCarousel.pre();
  }
  nextChart() {
    this.logSwitch = true;
    this.chartCarousel.next();
  }
  setFocus(event) {
    event.currentTarget.querySelector(".slick-dots-bottom").focus();
  }
  setDisplayData(data) {
    this.displayData = {
      ...this.displayData,
      ...data,
    };
    this.setChartDisplayDetails();
    this.displayDataSet = true;
  }
  setChartDisplayDetails() {
    let displayPeriod = this.defaultData.period;
    if (
      this.selectedValue === "trend-bar" ||
      this.selectedValue === "distribution-range"
    ) {
      const xData = this.displayData.tableData.Value.x;
      const startDate = xData[0];
      const endDate = xData[xData.length - 1];
      displayPeriod = `${startDate} to ${endDate}`;
    }
    this.displayData.period = ` - ${displayPeriod}`;
  }
  expandChart() {
    //expand popup
    this.chartPopupDataToUse = {
      ...this.dataToUse,
    };
    this.chartPopupType = this.chartType;
    this.chartPopupVisible = true;
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      "Chart_Expand",
      extraData,
      this.dataToUse.source,
      "Chart_Expand_Button",
    );
  }
  hideChartPopup() {
    this.chartPopupVisible = false;
    this.chartPopupType = "";
  }
}
